import { isAccountId } from '../constants/permissions';

const membershipId = (entry) =>
  entry?.hubSpotId || entry?.hubspotId || entry?.id;

export function postLoginPath({
  accounts = [],
  backoffice = false,
  platformAdmin = false,
  canAccessAllAccounts = false,
  lastAccountId = null,
} = {}) {
  const list = Array.isArray(accounts) ? accounts : [];
  const staff = Boolean(backoffice || platformAdmin || canAccessAllAccounts);
  const remembered = String(lastAccountId || '').trim();

  if (isAccountId(remembered)) {
    if (staff) return `/${remembered}/home`;
    const belongs = list.some((account) => String(membershipId(account)) === remembered);
    if (belongs) return `/${remembered}/home`;
  }

  if (!staff && list.length === 1 && membershipId(list[0])) {
    return `/${membershipId(list[0])}/home`;
  }

  return '/accounts';
}
